import { PromoType } from '@/components/blocks/FreeGiftV2/constants';
import { MarketInventoryIndex } from '@/components/blocks/FreeGiftV2/utils';
import {
	PromotionCombination,
	PurchaseGroup,
	RewardGroup,
} from '@/components/blocks/FreeGiftV2/types';
import { ProductType } from '@/data/types/Product';
import { CombinablePromotion } from '@/data/types/Promotions';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export interface FreeGiftPromotionContextValue {
	currentPartNumber: string;
	combinablePromotions: CombinablePromotion[];
	purchase: PurchaseGroup;
	reward: RewardGroup;
	promoThdCode?: PromoType;
	isPurchaseCombinable: boolean;
	purchaseQty: number;
	othersQty: number;
	rewardsQty: number;
	showUpToLabel: boolean;
	promoItems: ProductType[];
	marketInventory: MarketInventoryIndex;
	promotionGroups: PromotionCombination[];
	selectedPromotionIndex: number;
	setSelectedPromotionIndex: Dispatch<SetStateAction<number>>;
}

export const FreeGiftPromotionContext = createContext<FreeGiftPromotionContextValue | null>(null);

export const useFreeGiftPromotion = (): FreeGiftPromotionContextValue => {
	const context = useContext(FreeGiftPromotionContext);

	if (!context) {
		throw new Error('useFreeGiftPromotion must be used within a FreeGiftPromotionContext.Provider');
	}

	return context;
};
